import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
@Component({
  selector: 'app-view-animal-samples',
  templateUrl: './view-animal-samples.component.html',
  styleUrls: ['./view-animal-samples.component.css']
})
export class ViewAnimalSamplesComponent implements OnInit {
  getanimalsamplesviewApi:any;
  testdate:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService: CommonService) { }

 async ngOnInit() {
    let SamplesId = sessionStorage.getItem('samplesId');
    this.getanimalsamplesviewApi= "/animal_management/sample/"+SamplesId;
    (await this.commonService.getApi(this.getanimalsamplesviewApi)).subscribe(
      res => { 
        console.log(res.data);
        var date=res.data.tnam_sam_date_of_sample_collected;
         this.testdate = date.split('T');
        $("#SampleCollected").text(res.data.tnam_sam_sample_collected),
       $("#Description").text(res.data.tnam_sam_description)
      })
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
